<form [formGroup]="offerForm" class="checkbox-form checkbox-control">
  <se-fe-checkbox
    id="chk_agreement"
    formControlName="addItemToCart"
    class="checkbox checkbox-control__checkbox custom-checked__input">
    <ng-template seFeFormFieldLabel>
      <span class="checkbox-control__label">{{ agreementLabel }}</span>
    </ng-template>
  </se-fe-checkbox>
</form>
